<app-login></app-login>

@if (!hideSiteChrome) {
  <div class="container-fluid-top">
    <app-header></app-header>
  </div>
}
<div [@routeAnim]="getRoute(outlet)" style="position: relative;">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
@if (!hideSiteChrome) {
  <app-footer></app-footer>
  <app-loading-frame></app-loading-frame>
  <app-cart-sidebar></app-cart-sidebar>
  <app-chat-room></app-chat-room>
}

@if (isLoading) {
  <div class="route-loader">
    <div class="route-loader__box">
      <p class="route-loader__logo">sale<span>4</span>all</p>
      <div class="route-loader__spinner"></div>
    </div>
  </div>
}